import Length from "./Length";
import Rectangle from "./Rectangle";
import Area from "./Area";
import AbstractShape from "./AbstractShape";

export default class Polygon extends AbstractShape {
	static NAME = "polygon";

	constructor( width, side_amount ) {
		super();

		this.width = width;
		this.side_amount = side_amount;
	}

	get_name() {
		return Polygon.NAME;
	}

	get_enclosing_rectangle() {
		return new Rectangle( this.width, this.width );
	}

	get_area() {
		const radius = this.width.divide( 2 ).in_mm();
		const area = 0.5 * this.side_amount * radius * radius * Math.sin( ( 2 * Math.PI ) / this.side_amount );
		return new Area( area );
	}

	get_circumference() {
		const radius = this.width.divide( 2 ).in_mm();
		const side_length = 2 * radius * Math.sin( Math.PI / this.side_amount );
		return new Length( this.side_amount * side_length );
	}

	get_width() {
		return this.width;
	}

	get_side_amount() {
		return this.side_amount;
	}

	get_maximum_dimensions( maximum_rectangle ) {
		return {
			width: maximum_rectangle.get_shortest_side()
		};
	}

	get_dimension_keys() {
		return [ "width" ];
	}

	get_modifier_keys() {
		return [ "side_amount" ];
	}

	serialize_primitives() {
		return {
			width: this.width.in_mm(),
			side_amount: this.side_amount,
		};
	}

	static deserialize_primitives( primitives ) {
		return new Polygon(
			new Length( primitives.width ),
			parseInt( primitives.side_amount, 10 )
		);
	}
}
